<template>
    <nav class="sidebar-nav">
        <SidebarNavItem to="/customers" icon="team" title="Manage Customers" />
        <SidebarNavItem to="/organisations" icon="bank" title="Manage Organisations" />
        <SidebarNavItem to="/users" icon="user" title="Manage Users" />
        <SidebarNavItem to="/industries" icon="database" title="Manage Holders" />
        <SidebarNavItem to="/bank-categories" icon="tags" title="Bank Categories" />
        <SidebarNavItem to="/product-blacklist" icon="stop" title="Product Blacklist" />
        <SidebarNavItem to="/roadmap" icon="fork" title="Roadmapping" />
        <SidebarNavItem to="/usage" icon="stock" title="Usage" />
        <SidebarNavItem to="/sso" icon="cluster" title="Manage SSO" />
        <SidebarNavItem to="/suppliers" icon="shop" title="Supplier Questions" />
    </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SidebarNavItem from './SidebarNavItem.vue';

export default defineComponent({
    name: 'ProductCloudSidebar',
    components: {
        SidebarNavItem
    }
});
</script>

<style lang="scss" scoped>
.sidebar-nav {
    display: flex;
    flex-direction: column;
}
</style>
